/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-09 10:43:35
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 18:09:30
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/CarouselAdaptor/index.tsx
 */
import React from 'react';

import css from './css.module.less';

import _Carousel from 'src/constrains/DraggableModules/Components/Carousel';
import _ProductCarousel from 'src/constrains/DraggableModules/Components/ProductCarousel';
import _ArticleCarousel from 'src/constrains/DraggableModules/Components/ArticleCarousel';

import DataHOC from 'src/constrains/DraggableModules/Components/HOC/DataProcessHOC';

import { EnumModuleType } from 'src/types/common/module';
import AdaSelection from 'src/constrains/DraggableModules/Components/AdaptorSelection';

const CarouselAdaptor = (props) => {
  const {
    staticData,
    onModuleTypeChange,
    draggableId,

    allDisabled,
    ...rest
  } = props;

  const { moduleType } = staticData;
  const handleOnModuleTypeChange = (e) => {
    const type = e.target.value;

    const data = { moduleType: type, id: draggableId };
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };
  const Dict = React.useMemo(() => {
    return {
      [EnumModuleType.Carousel]: _Carousel,
      [EnumModuleType.ProductCarousel]: _ProductCarousel,
      [EnumModuleType.ArticleCarousel]: _ArticleCarousel,
    };
  }, []);
  const generateModule = () => {
    const Module = Dict[moduleType];
    return (
      <Module
        {...rest}
        draggableId={draggableId}
        staticData={staticData}
        disabled={allDisabled}
      />
    );
  };
  return (
    <div className={css.container}>
      <AdaSelection
        title='Carousel Type'
        list={[
          {
            value: EnumModuleType.Carousel,
            label: 'Image',
            className: css.radioItem,
          },
          {
            value: EnumModuleType.ProductCarousel,
            label: 'Product',
            className: css.radioItem,
          },
          {
            value: EnumModuleType.ArticleCarousel,
            label: 'Content Page',
          },
        ]}
        value={moduleType}
        onChange={handleOnModuleTypeChange}
        disabled={allDisabled}
      />{' '}
      {/* <Section bottomBorder>
        <ItemWrapper title='Carousel Type'>
          <Radio
            className={css.radioContainer}
            radioList={[
              {
                value: EnumModuleType.Carousel,
                label: 'Carousel',
                className: css.radioItem,
              },
              {
                value: EnumModuleType.ProductCarousel,
                label: 'Product Carousel',
              },
            ]}
            value={moduleType}
            onChange={handleOnModuleTypeChange}
          />
        </ItemWrapper>
      </Section> */}
      {generateModule()}
    </div>
  );
};
export default DataHOC(CarouselAdaptor);
